export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 1,
    title: "2025年必备的10款效率工具推荐",
    excerpt: "在快节奏的数字时代，善用工具是提升效率的关键。本文精选了10款2025年最值得尝试的效率工具，从笔记管理到自动化工作流，助你事半功倍。",
    content: `<p>在这个信息爆炸的时代，选择一款合适的效率工具可以极大提升我们的工作和学习效率。2025年，AI驱动的工具正在改变我们的工作方式。以下是本年度最值得推荐的10款效率工具。</p>
<h2>1. Notion - 全能型知识管理</h2>
<p>Notion 已经从一个简单的笔记工具发展为一站式工作空间。它将文档、数据库、项目管理、Wiki 等功能融为一体。2025年的 Notion 加入了更强大的 AI 功能，可以智能整理笔记、自动生成摘要，甚至帮助你制定项目计划。</p>
<h2>2. Raycast - Mac 效率启动器</h2>
<p>Raycast 重新定义了快捷启动工具。它不仅是应用启动器，更是连接各种在线服务的桥梁。通过插件系统，你可以在 Raycast 中完成翻译、搜索、管理任务等各种操作，无需切换到浏览器或打开其他应用。</p>
<h2>3. Tango - 流程记录工具</h2>
<p>Tango 能够自动捕获你的操作步骤，并生成带有截图和文字说明的分步指南。无论是制作团队培训文档还是客户操作手册，Tango 都能大幅节省你的时间。</p>
<h2>4. Arc 浏览器</h2>
<p>Arc 不仅仅是一个浏览器，更是一个工作空间组织者。它的侧边栏设计、空间管理和分屏功能让多任务处理变得前所未有的流畅。2025年 Arc 推出的 AI 搜索功能更是让信息检索效率翻倍。</p>
<h2>5. Loom - 异步视频沟通</h2>
<p>Loom 让视频沟通变得像发消息一样简单。录制屏幕和摄像头，一键分享视频链接，减少了大量不必要的会议时间。2025年 Loom 的 AI 功能可以自动生成视频字幕和摘要。</p>
<h2>6. Todoist - 任务管理专家</h2>
<p>Todoist 以其简洁的界面和强大的自然语言处理功能著称。你只需输入"明天下午3点开会"，Todoist 就能自动识别时间并创建提醒。跨平台同步让任务管理无处不在。</p>
<h2>7. Readwise - 阅读回顾助手</h2>
<p>Readwise 自动收集你在 Kindle、微信读书、Instapaper 等平台的高亮标注，并通过间隔重复的方式帮你回顾这些内容。知识内化从未如此简单。</p>
<h2>8. Obsidian - 双向链接笔记</h2>
<p>Obsidian 以其强大的双向链接和图谱功能，成为构建个人知识体系的首选工具。2025年的插件生态已经非常成熟，几乎可以满足任何个性化需求。</p>
<h2>9. Cron - 智能日历</h2>
<p>Cron 由 Notion 团队打造，重新定义了日历应用。它的智能时区管理、团队可用性查看和 Notion 深度集成，让日程安排变得轻松自如。</p>
<h2>10. Figma - 协作设计平台</h2>
<p>Figma 已经成为设计领域的标准工具，2025年它进一步强化了开发者模式和白板功能，让设计师和开发者的协作更加高效。</p>
<h2>总结</h2>
<p>工欲善其事，必先利其器。选择适合自己的效率工具组合，远比盲目追求工具数量更重要。建议从你最迫切的需求出发，选择1-2款工具深度使用，逐步构建你的效率工作流。</p>`,
    category: "gongju-tuijian",
    author: "柠檬小编",
    date: "2025-08-05",
    readTime: "8分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20setup%20with%20laptop%20and%20productivity%20tools%20on%20a%20clean%20wooden%20desk%2C%20soft%20natural%20lighting%20from%20a%20large%20window%2C%20warm%20neutral%20color%20palette%2C%20professional%20editorial%20photography%20with%20shallow%20depth%20of%20field%2C%20organized%20and%20peaceful%20atmosphere&width=800&height=450&seq=article-2025-tools&orientation=landscape",
    tags: ["效率工具", "推荐", "2025"],
  },
  {
    id: 2,
    title: "设计师必知的8个配色工具网站",
    excerpt: "配色是设计中最基础也最重要的技能之一。本文整理了8个专业配色工具网站，帮助设计师和非设计师都能轻松创建和谐的色彩方案。",
    content: `<p>好的配色能让设计作品焕发生机，而糟糕的配色则会毁掉一切努力。无论你是专业设计师还是偶尔需要做图的运营人员，这些配色工具都能帮到你。</p>
<h2>1. Coolors.co - 配色方案生成器</h2>
<p>Coolors 是目前最受欢迎的配色工具之一。按下空格键即可随机生成配色方案，用户也可以锁定喜欢的颜色后继续调整。它还支持从图片中提取配色方案，并提供了丰富的调色板社区供参考。</p>
<h2>2. Adobe Color - 专业配色轮盘</h2>
<p>Adobe Color（原 Kuler）提供了基于色彩理论的配色规则，包括互补色、三角色、四边形等。用户可以从色轮上直观地调整颜色关系，还可以从 Behance 社区作品中提取配色灵感。</p>
<h2>3. ColorHunt - 精选调色板</h2>
<p>ColorHunt 是一个由社区驱动的调色板分享平台，每天更新精选的配色方案。每个调色板只包含4种颜色，简洁实用。平台的分类标签和历史最受欢迎排行榜让发现好配色变得非常容易。</p>
<h2>4. Colormind - AI 智能配色</h2>
<p>Colormind 使用深度学习算法来生成和谐的配色方案。它可以从图片、网站或用户输入的颜色中学习，并生成与之匹配的配色。内置的网站配色预览功能让效果一目了然。</p>
<h2>5. Paletton - 配色方案设计工具</h2>
<p>Paletton 提供了精确的色轮控制，支持单色、相邻色、三色、四色等多种配色模式。独特的预览面板可以实时查看配色在网页中的效果，是前端开发者的得力助手。</p>
<h2>6. UI Gradients - 渐变配色集合</h2>
<p>UI Gradients 收录了大量精美的渐变色搭配方案，用户可以直接复制 CSS 代码使用。每个渐变都有独特的命名，方便记忆和分享。</p>
<h2>7. Happy Hues - 配色场景教学</h2>
<p>Happy Hues 不只提供调色板，还展示了配色在实际 UI 场景中的应用效果。每种配色方案都配有具体的颜色使用指南，帮助用户理解如何在页面中合理分配颜色。</p>
<h2>8. Picular - 关键词色彩搜索引擎</h2>
<p>Picular 是一款独特的色彩搜索工具。输入任何关键词，它会从 Google 图片搜索结果中提取相关的主要颜色。比如搜索"海洋"会得到各种蓝色系，搜索"秋天"会得到暖橙和棕色系。</p>
<h2>总结</h2>
<p>配色是一门科学也是艺术。掌握这些工具可以让你在配色时更加得心应手，但最终的判断还是来自你的审美和实践。多观察、多练习，配色能力一定会不断提升。</p>`,
    category: "sheji-linggan",
    author: "柠檬小编",
    date: "2025-08-02",
    readTime: "6分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20color%20palette%20display%20on%20a%20designer%20desk%20with%20color%20swatches%20and%20a%20monitor%20showing%20design%20software%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20warm%20cream%20background%20with%20textured%20paper%2C%20creative%20workspace%20photography%20with%20harmonious%20composition&width=800&height=450&seq=article-color-tools&orientation=landscape",
    tags: ["配色", "设计工具", "UI设计"],
  },
  {
    id: 3,
    title: "从零开始自学编程：一份完整的路线图",
    excerpt: "想学编程但不知道从何开始？本文为编程零基础的学习者提供了一份详细的入门路线图，涵盖学习顺序、推荐资源和常见误区。",
    content: `<p>越来越多的人意识到编程是一项非常有价值的技能。无论是转行、提升工作效率，还是实现自己的创意想法，编程都能帮到你。以下是为零基础学习者准备的完整路线图。</p>
<h2>第一步：明确学习目标</h2>
<p>在开始之前，先问自己：你为什么想学编程？是想做网页开发？移动应用？数据分析？还是自动化办公？不同的目标对应不同的技术栈和学习路径。建议先花1-2天了解各个方向，选择最吸引你的那个。</p>
<h2>第二步：选择第一门语言</h2>
<p>对于零基础学习者，推荐从以下语言中选择：</p>
<ul>
<li><strong>Python</strong>：语法简洁，上手快，适合数据分析、AI、自动化脚本等方向</li>
<li><strong>JavaScript</strong>：Web 开发必备，能立即在浏览器中看到效果，反馈感强</li>
<li><strong>HTML/CSS</strong>：网页结构的基石，适合想快速看到可视成果的学习者</li>
</ul>
<h2>第三步：掌握基础概念</h2>
<p>无论选择哪门语言，以下核心概念必须掌握：变量与数据类型、条件判断、循环、函数、数组/列表、对象/字典。建议每天保持1-2小时的练习时间，坚持比强度更重要。</p>
<h2>第四步：做项目驱动学习</h2>
<p>学完基础概念后，尽快开始做实际项目。从小项目开始：一个计算器、一个待办事项列表、一个个人博客页面。在项目中学到的知识更牢固，也更有成就感。</p>
<h2>第五步：利用优质学习资源</h2>
<p>推荐的免费学习平台：freeCodeCamp（英文综合性教程）、中国大学MOOC（国内大学课程）、B站技术区（海量中文教程视频）、LeetCode（刷题练习算法）</p>
<h2>常见误区</h2>
<ul>
<li><strong>只看不写</strong>：编程是技能，必须动手练习，仅看教程是无法学会的</li>
<li><strong>追求完美</strong>：初学者的代码不需要完美，先让代码跑起来，再优化</li>
<li><strong>频繁切换方向</strong>：选定一个方向后至少坚持3个月，不要因为遇到困难就换</li>
</ul>
<h2>总结</h2>
<p>学习编程是一场马拉松，不是短跑。保持耐心，持续练习，遇到问题时善用搜索引擎和社区求助。记住，每个优秀的程序员都是从"Hello World"开始的。</p>`,
    category: "xuexi-pingtai",
    author: "柠檬小编",
    date: "2025-07-28",
    readTime: "7分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20coding%20workspace%20with%20a%20laptop%20displaying%20code%20editor%20screen%2C%20warm%20desk%20lamp%20light%2C%20notebook%20and%20coffee%20on%20the%20side%2C%20modern%20home%20office%20setup%2C%20soft%20natural%20light%20through%20window%2C%20peaceful%20learning%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=article-learn-code&orientation=landscape",
    tags: ["编程入门", "学习路线", "自学"],
  },
  {
    id: 4,
    title: "远程办公必备的协作工具大盘点",
    excerpt: "远程办公已经成为越来越多企业的常态。本文盘点了团队远程协作中不可或缺的工具，覆盖沟通、项目管理、文件协作等各个方面。",
    content: `<p>远程办公已经从一个临时方案变成了许多公司的长期选择。高效的远程协作离不开合适的工具支持。本文将从不同协作场景出发，为您推荐最适合的远程办公工具。</p>
<h2>即时通讯：飞书 vs 钉钉 vs 企业微信</h2>
<p>三大主流企业通讯工具各有特色。飞书以文档协作和日历整合见长；钉钉在考勤管理和审批流程上更加完善；企业微信则天然与微信打通，适合需要频繁与外部客户沟通的团队。建议根据团队规模和工作流选择。</p>
<h2>视频会议：腾讯会议 vs Zoom</h2>
<p>腾讯会议在国内的使用体验非常流畅，与微信生态的整合也很到位。Zoom 在国际会议中更受欢迎，功能也更丰富。如果团队有跨国协作需求，建议两个都保持可用。</p>
<h2>项目管理：Notion vs 飞书多维表格</h2>
<p>Notion 的灵活性和强大的数据库功能使其成为项目管理的最佳选择之一。飞书多维表格则更贴合国内用户的使用习惯，与飞书生态无缝衔接。小团队建议从飞书多维表格开始，成本低且容易上手。</p>
<h2>文件协作：石墨文档 vs 腾讯文档</h2>
<p>两款在线文档工具在基础功能上已经非常接近。石墨文档在多人实时编辑的流畅度上略有优势，腾讯文档则在与微信/QQ的分享体验上更胜一筹。</p>
<h2>设计协作：FigJam vs 飞书白板</h2>
<p>Figma 的 FigJam 是在线白板的行业标杆，功能强大且模板丰富。飞书白板作为后来者，发展迅速，与飞书的深度整合是最大优势。如果团队已经在用飞书，白板是不错的选择。</p>
<h2>总结</h2>
<p>工具是辅助，人才是核心。选择工具时应优先考虑团队的接受度和使用门槛，避免一味追求功能强大而忽略实际使用率。建议每个协作场景只保留1-2款核心工具，减少切换成本。</p>`,
    category: "bangong-xietong",
    author: "柠檬小编",
    date: "2025-07-20",
    readTime: "6分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20cozy%20home%20office%20setup%20with%20dual%20monitors%20showing%20collaboration%20tools%2C%20ergonomic%20chair%2C%20plants%20for%20decoration%2C%20warm%20natural%20lighting%20from%20a%20large%20window%2C%20minimalist%20Scandinavian%20interior%20design%2C%20professional%20yet%20comfortable%20atmosphere%2C%20clean%20and%20organized%20workspace&width=800&height=450&seq=article-remote-work&orientation=landscape",
    tags: ["远程办公", "协作工具", "团队效率"],
  },
  {
    id: 5,
    title: "免费商用图片网站合集：告别图片版权焦虑",
    excerpt: "做内容最怕的就是图片版权问题。本文整理了10个高质量免费可商用的图片素材网站，涵盖摄影、插画、图标等多个类型。",
    content: `<p>无论是制作PPT、写公众号文章，还是设计运营海报，图片都是必不可少的素材。然而，随意使用网络图片可能带来版权风险。以下网站提供的图片均可免费商用，让你告别版权焦虑。</p>
<h2>1. Unsplash - 摄影图片首选</h2>
<p>Unsplash 拥有超过200万张高质量摄影图片，所有图片均可免费商用，无需署名。图片风格偏向艺术化和生活化，适合品牌宣传和社交媒体配图。</p>
<h2>2. Pexels - 视频与图片</h2>
<p>Pexels 不仅提供高质量图片，还有免费可商用的视频素材。图片风格更加多元，覆盖商业、生活、科技等多个类别。支持中文搜索，对国内用户非常友好。</p>
<h2>3. Pixabay - 综合素材库</h2>
<p>Pixabay 拥有超过250万张图片、视频和音效素材，全部免费可商用。除了摄影作品，还包含大量插画和矢量图，是综合性最强的免费素材平台之一。</p>
<h2>4. Burst (by Shopify) - 电商图片</h2>
<p>Burst 是 Shopify 旗下的免费图片网站，专注于电商场景。如果你需要产品展示、店铺装修相关的图片，Burst 是绝佳选择。</p>
<h2>5. Foodiesfeed - 美食图片</h2>
<p>专门的美食摄影图片网站，所有图片均可免费商用。对于美食博主和餐饮行业从业者来说，这是不可多得的宝藏。</p>
<h2>6. Nappy - 多元人像图片</h2>
<p>Nappy 提供高质量的多元族裔人像摄影图片。如果你的设计需要展示多样性和包容性，Nappy 是很好的选择。</p>
<h2>7. DrawKit - 插画素材</h2>
<p>DrawKit 提供精美的手绘风格插画，部分免费可商用。插画风格统一、颜色协调，非常适合用于网站首页和 APP 引导页设计。</p>
<h2>8. unDraw - SVG 插画</h2>
<p>unDraw 提供开源 SVG 插画，可以在线调整颜色以匹配品牌风格。所有插画都可以免费商用，无需署名。支持 SVG 和 PNG 格式下载。</p>
<h2>9. Humaaans - 人物插画</h2>
<p>Humaaans 专注于人物场景插画，你可以自由组合不同的角色、服装、姿势和背景。非常适合用于网页设计和产品展示。</p>
<h2>10. Icons8 - 图标与插图</h2>
<p>Icons8 提供了海量图标、插图和照片，免费版需要署名，付费版可免署名。它的图标风格统一，支持在线编辑颜色和大小。</p>
<h2>总结</h2>
<p>有了这些免费素材网站，日常的内容创作基本不用担心图片版权问题了。但建议在使用前仍然确认一下每个网站的最新许可协议，因为政策可能会调整。记住：尊重版权，从使用正版素材开始。</p>`,
    category: "ziyuan-xiazai",
    author: "柠檬小编",
    date: "2025-07-15",
    readTime: "7分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20flat%20lay%20arrangement%20of%20various%20photography%20prints%20and%20a%20camera%20on%20a%20minimalist%20white%20desk%2C%20soft%20natural%20lighting%20from%20the%20side%2C%20warm%20neutral%20tones%20with%20pops%20of%20pastel%20colors%2C%20creative%20studio%20aesthetic%2C%20clean%20and%20artistic%20composition%2C%20professional%20product%20photography&width=800&height=450&seq=article-free-images&orientation=landscape",
    tags: ["免费图片", "素材资源", "版权"],
  },
  {
    id: 6,
    title: "2025年AI工具大盘点：普通人也能用的AI神器",
    excerpt: "AI不再是科幻电影中的概念，它已经深入到我们的日常工作和生活中。本文盘点了20款普通人也能轻松上手的AI工具。",
    content: `<p>2025年，AI工具的普及速度超乎想象。从写作到绘画，从编程到视频制作，AI正在改变我们工作的方式。以下是为大家精心整理的AI工具合集。</p>
<h2>AI 对话与写作</h2>
<p><strong>ChatGPT</strong> 依然是AI对话领域的领头羊，GPT-5的推出让对话体验更加自然流畅。<strong>Kimi Chat</strong> 由月之暗面打造，支持超长文本处理，特别适合需要分析大量文档的场景。<strong>通义千问</strong> 是阿里的AI助手，与钉钉和阿里云生态深度整合。</p>
<h2>AI 绘画与设计</h2>
<p><strong>Midjourney</strong> 仍然是AI绘画的标杆，V7版本在细节表现力上达到了新高度。<strong>Stable Diffusion</strong> 开源免费，可本地部署，社区生态极为活跃。<strong>LiblibAI</strong> 是国内最大的Stable Diffusion模型分享社区，提供海量在线模型。</p>
<h2>AI 编程助手</h2>
<p><strong>GitHub Copilot</strong> 已经从代码补全工具升级为智能编程伙伴，支持代码解释、测试生成等高级功能。<strong>Cursor</strong> 是基于VS Code的AI编程编辑器，深度整合了AI能力，是程序员的新宠。<strong>Windsurf</strong> 提供了独特的AI Flow编程模式，让代码编写如丝般顺滑。</p>
<h2>AI 视频制作</h2>
<p><strong>Sora</strong> 由OpenAI推出，支持文字生成高质量视频。<strong>Runway</strong> 是最早的AI视频工具之一，提供了丰富的视频编辑AI功能。<strong>剪映</strong> 整合了字节跳动的AI能力，是国内最易上手的AI视频工具。</p>
<h2>AI 办公效率</h2>
<p><strong>Gamma</strong> 可以一键生成精美的PPT和文档。<strong>Otter.ai</strong> 是AI会议记录工具，自动生成会议纪要和待办事项。<strong>Perplexity</strong> 是AI搜索引擎，提供带来源引用的精准回答。</p>
<h2>总结</h2>
<p>AI工具的选择原则：从你真正的需求出发，选择1-2款工具深入学习，而不是浅尝辄止地尝试所有工具。记住，AI是放大器，它放大的是你的能力和想法。先想清楚你要做什么，再选择合适工具。</p>`,
    category: "gongju-tuijian",
    author: "柠檬小编",
    date: "2025-07-10",
    readTime: "8分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Futuristic%20AI%20concept%20scene%20with%20a%20sleek%20laptop%20displaying%20glowing%20intelligent%20interface%2C%20holographic%20elements%20floating%20above%20the%20screen%2C%20warm%20ambient%20lighting%20in%20a%20modern%20minimalist%20office%2C%20clean%20white%20and%20warm%20gray%20color%20palette%2C%20professional%20technology%20photography%20with%20soft%20depth%20of%20field&width=800&height=450&seq=article-ai-tools&orientation=landscape",
    tags: ["AI工具", "人工智能", "效率"],
  },
];

export const getArticleById = (id: number): Article | null => {
  return articles.find((a) => a.id === id) || null;
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getRecentArticles = (limit: number = 5): Article[] => {
  return [...articles]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, limit);
};